import { createCustomFieldFactory } from '../customFieldFactory';
import { CustomFieldTypes } from '../customFieldTypes';
import TspCheckbox from './TspCheckbox';
import TspCheckboxList from './TspCheckboxList';
import TspDropdownList from './TspDropdownList';
import TspEmailWithConfirmation from './TspEmailWithConfirmation';
import TspFileUpload from './TspFileUpload';
import TspRadioButtonList from './TspRadioButtonList';
import TspRichText from './TspRichText';
import TspSubmitButton from './TspSubmitButton';
import TspTelephoneWithDialCode from './TspTelephoneWithDialCode';
import TspText from './TspText';

export function createTspFieldFactory() {
  const factory = createCustomFieldFactory();

  factory.setComponent(CustomFieldTypes.Button, TspSubmitButton);
  factory.setComponent(CustomFieldTypes.RadioButtonList, TspRadioButtonList);
  factory.setComponent(CustomFieldTypes.Checkbox, TspCheckbox);
  factory.setComponent(CustomFieldTypes.CheckboxList, TspCheckboxList);
  factory.setComponent(CustomFieldTypes.Text, TspText);
  factory.setComponent(CustomFieldTypes.DropdownList, TspDropdownList);
  factory.setComponent(CustomFieldTypes.EmailWithConfirmation, TspEmailWithConfirmation);
  factory.setComponent(CustomFieldTypes.FileUpload, TspFileUpload);
  factory.setComponent(CustomFieldTypes.RichText, TspRichText);
  factory.setComponent(CustomFieldTypes.TelephoneWithDialCode, TspTelephoneWithDialCode);

  return factory;
}
